import {Injectable} from '@angular/core';
import {WmWoundDocumentationsTable} from '../../tables/wound-management/wm-wound-documentations.table';
import {OrganisationKeysService} from './organisation-keys.service';
import {StorageService} from './storage.service';
import {db} from '../../tables/db.service';
import {OrganisationsService} from './organisations.service';
import {UserService} from './user.service';
import {CustomerDocumentsTable} from '../../tables/customer-documents/customer-documents.table';
import {AuthService} from './auth.service';
import {CustomersService} from '../customers/customers.service';

@Injectable({
  providedIn: 'root'
})
export class AppResetService {
  constructor(
    private wmWoundDocumentationsTable: WmWoundDocumentationsTable,
    private storageService: StorageService,
    private customersService: CustomersService,
    private customerDocumentsTable: CustomerDocumentsTable,
  ) {

  }

  /**
   *
   */
  public async hardReset(): Promise<void> {
    await this.storageService.clear([
      OrganisationKeysService.storageKey,
      OrganisationsService.storageKey
    ]);

    // Files are deleted in the respective table
    await this.wmWoundDocumentationsTable.clear(true);

    // Clear all tables except storage
    await this.customerDocumentsTable.clear();

    // Clear selected customer documents
    await this.customersService.selectCustomer(null);

    // Clear all tables except storage
    const tables = db.tables;
    for (const table of tables) {
      if (table.name !== 'storage') {
        table.clear();
      }
    }

    await UserService.removeUser();
  }

  /**
   *
   */
  public async resetData(): Promise<void> {
    await this.storageService.clear([
      OrganisationKeysService.storageKey,
      OrganisationsService.storageKey,
      AuthService.storageKey
    ]);

    // Files are deleted in the respective table
    await this.wmWoundDocumentationsTable.clear(true);

    // Clear all tables except storage
    await this.customerDocumentsTable.clear();

    // Clear all tables except storage
    const tables = db.tables;
    for (const table of tables) {
      if (table.name !== 'storage') {
        await table.clear();
      }
    }
  }

}
